import * as React from 'react';
import { SvgImage } from '../common';
import RelatedContentProps from './type';
import { Container } from '../helpers/Grid';
import NewsCard from '../NewsCard';
import { GatewayCard } from '../GatewayCarousel';
import NewsCardProps from '../NewsCard/type';
import { Card } from '../GatewayCarousel/type';
import FeatureNewsCard from '../FeaturedNewsCard';
import './styles.scss';

const RelatedContent = ({
  title,
  relatedItems,
  moreNewsLink,
  featuredItem,
  isPages = false,
}: RelatedContentProps) => (
  <div className={`related-content ${featuredItem ? 'related-content--has-featured' : ''}`}>
    <Container>
      <div className="related-content__inner">
        <div className="related-content__title">
          <h3>
            {title}
          </h3>
        </div>
        {featuredItem && (
          <div className="related-content__featured-item-mobile">
            <FeatureNewsCard {...featuredItem} />
          </div>
        )}
        <div className="related-content__items">
          {featuredItem && (
            <div className="related-content__featured-item">
              <FeatureNewsCard {...featuredItem} />
            </div>
          )}
          {!isPages && (
            <>
              {relatedItems.map((relatedItem) => (
                <NewsCard {...relatedItem as NewsCardProps} />
              ))}
            </>
          )}
          {isPages && (
            <>
              {relatedItems.map((relatedItem) => (
                <React.Fragment key={relatedItem.url}>
                  <GatewayCard {...relatedItem as Card} />
                </React.Fragment>
              ))}
            </>
          )}

        </div>
      </div>

      <>
        {moreNewsLink && (
          <a href={moreNewsLink.url} className="related-content__link">
            <span>{moreNewsLink.title}</span>
            <SvgImage title={moreNewsLink.title} reference="#icon-long-arrow-right" />
          </a>
        )}
      </>
    </Container>
  </div>
);

export default RelatedContent;
